
import moment from "moment"

const bannerIndex = (data, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/banner', {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			},
			params: {
				user_str_id: user_str_id ? user_str_id : null,
				...data
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const bannerViews = (ids, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		if(!ids || ids.filter(id => !!id).length == 0) return reject()
		axios.post('/api/banner/views', {ids: ids}, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			},
			params: { user_str_id: user_str_id ? user_str_id : null },
            withCredentials: true
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const bannerClick = (id, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/banner/' + id + '/click', {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			},
			params: { user_str_id: user_str_id ? user_str_id : null },
            withCredentials: true
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const bannerDetails = (post_id, placement, categories, locations, startsAt, expiresAt, isPlaceholder, canBePaid, access_token) => {
	return new Promise((resolve, reject) => {
		var data = {}
		if(post_id) data.post_id = post_id
		if(placement) data.placement = placement
		if(categories) data.categories = categories
		if(locations) data.locations = locations
		if(startsAt) data.starts_at = startsAt
		if(expiresAt) data.expires_at = expiresAt
		if(typeof isPlaceholder != 'undefined' && isPlaceholder !== null) data.is_placeholder = isPlaceholder
		if(typeof canBePaid != 'undefined' && canBePaid !== null) data.can_be_paid = canBePaid
		axios.post('/api/banner/details', data, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response.data)
		})
	})
}

const bannerDetailsBy = (banner_id, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/banner/details/' + banner_id, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response.data)
		})
	})
}

const bannerCreate = (banner, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/banner', banner, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const userBanners = (user_id, search, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/banner/user/' + user_id + (search ? ('?search=' + search) : ''), {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const bannerShow = (id, params, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/banner/' + id, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			},
			params: params ? params : null
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const bannerDelete = (id, access_token) => {
	return new Promise((resolve, reject) => {
		axios.delete('/api/banner/' + id, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const bannerPurchase = (id, method, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/banner/purchase/' + id + '/' + method, {}, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const bannerUpdate = (id, data, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/banner/' + id, data, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

export const bannerPaymentIntent = (id, data, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/banner/' + id + '/intent', data, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const nl2br = str => {
    if (typeof str === 'undefined' || str === null) { return '' }
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br />' + '$2')
}

const bannerPlaces = [
    {
        key: 'full_size',
        name: 'Main banner - full size',
        type: '3-room',
        place: 'main'
    },
    {
        key: 'two_thirds',
        name: 'Main banner - 2/3 of full size',
        type: '2-room',
        place: 'main'
    },
    {
        key: 'one_third',
        name: 'Main banner - 1/3 of full size',
        type: '1-room',
        place: 'main'
    },
    {
        key: 'text_ticker_one',
        name: 'Text ticker above main banner',
        type: 'text-line',
        place: 'main-line-1'
    },
    {
        key: 'text_ticker_two',
        name: 'Text ticker under main banner',
        type: 'text-line',
        place: 'main-line-2'
/*
    },
    {
        key: 'advanced_banner',
        name: 'Advanced banner place',
        type: 'advanced-banner'
*/
    }
]

const placementKeyBy = banner => {
    const placement = banner.placements && banner.placements[0] ? banner.placements[0] : null
    const prefix = placement && placement.categories && placement.categories.length > 0 ? 'category_' : 'main_'
    return prefix + bannerPlaces.filter(item => item.type == banner.type && item.place == banner.place)[0].key
}

const bannerPlaceNameBy = key => {
    var base_key = key.replace('main_', '').replace('category_', '').replace('sub_', '')
    if(base_key.indexOf('.') != -1) base_key = base_key.split('.')[0]
    return bannerPlaces.filter(item => item.key == base_key)[0].name
}

const defaultBgImages = [
    {id: 'default-1', urls: {'2000_2000': '/images/default-banner-bg.jpg'}},
    {id: 'default-2', urls: {'2000_2000': '/images/default-yellow-bg.jpg'}},
    {id: 'default-3', urls: {'2000_2000': '/images/default-light-bg.jpg'}},
]

const getImages = (id, images) => {
    if(!id){
        if(images && images.length > 0){
            return images.filter((item, i) => i == 0)
        }else{
            return defaultBgImages.filter((item, i) => i == 0)
        }
    }else{
        if(images && images.length > 0 && !id.toString().includes('default-')){
            return images.filter(item => item.id == id)
        }else{
            return defaultBgImages.filter(item => item.id == id)
        }
    }
}

const rgbaToHtml = (rgba, defaultColor) => rgba ? ('rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a + ')') : defaultColor ? defaultColor : '#ffffff'

const bannerProperty = (banner, property, defaultValue) => {
    return banner.options && banner.options.settings && banner.options.settings[property] ? banner.options.settings[property] : defaultValue
}

const convertBanner = _banner => {
	return {
        banner_status: _banner.status,
        banner_id: _banner.id,
        linkTo: _banner.link_to,
        isPlaceholder: _banner.is_placeholder > 0 ? true : false,
        title: bannerProperty(_banner, 'title', ''),
        description: bannerProperty(_banner, 'description', ''),
        images: _banner.images && _banner.images.length > 0 ? _banner.images : getImages(bannerProperty(_banner, 'image_id')),
        templateType: bannerProperty(_banner, 'template', 'default'),

        headerColor: bannerProperty(_banner, 'headerColor', ''),
        headerFontSize: bannerProperty(_banner, 'headerFontSize', ''),
        headerFontFamily: bannerProperty(_banner, 'headerFontFamily', ''),
        headerShadow: bannerProperty(_banner, 'headerShadow', ''),
        descColor: bannerProperty(_banner, 'descColor', ''),
        descFontSize: bannerProperty(_banner, 'descFontSize', ''),
        descFontFamily: bannerProperty(_banner, 'descFontFamily', ''),
        descShadow: bannerProperty(_banner, 'descShadow', ''),
        backgroundColor: bannerProperty(_banner, 'backgroundColor', ''),
        backgroundColorActive: bannerProperty(_banner, 'backgroundColorActive', ''),

        startsAt: _banner.starts_at ? moment(_banner.starts_at).format('YYYY-MM-DD') : null,
        expiresAt: _banner.expires_at ? moment(_banner.expires_at).format('YYYY-MM-DD') : null
    }
}

const convertLocations = locations => {
	return locations.map(location => {
            return {
                id: location.id,
                name: location.name,
                type: location.type,
                parent_name: location.location ? location.location.name : null,
                parent_ids: [ location.parent_id, location.location ? location.location.parent_id : null ].filter(item => !!item)
            }
        }
    )
}

const postToBanner = (type, _banner) => {

    let description = _banner.description

    const haveATitle = !['3-room', '2-room', '1-room'].includes(type)

    const banner = {
        banner_id: _banner.banner_id,
        type: type,
        title: haveATitle ? _banner.title : null,
        description: haveATitle ? _banner.description : null,
        images: _banner.images,
        options: {
            settings: {
                title: _banner.title,
                description: description,
                template: _banner.templateType,
                image_id: _banner.images && _banner.images[0] && _banner.images[0].id,
                headerColor: _banner.headerColor,
                headerFontSize: _banner.headerFontSize,
                headerFontFamily: _banner.headerFontFamily,
                headerShadow: _banner.headerShadow,
                descColor: _banner.descColor,
                descFontSize: _banner.descFontSize,
                descFontFamily: _banner.descFontFamily,
                descShadow: _banner.descShadow,
                backgroundColor: _banner.backgroundColor,
                backgroundColorActive: _banner.backgroundColorActive
            },
        },
        is_placeholder: !!_banner.isPlaceholder,
        link_to: _banner.linkTo,
        starts_at: moment(_banner.startsAt).utc(),
        expires_at: moment(_banner.expiresAt).utc(),
        html: `
            <div class="h-100 d-flex flex-column justify-content-center" style="background-color: rgba(0,0,0,0);">
                <div class="row">
                    <div class="col-lg-11 mx-auto">
                        <h4
                            class="h1 text-center text-dark font-weight-bold"
                            style="text-shadow: 0px -1px 1px #000000, 0 1px 1px rgba(255, 255, 255, 0.5)"
                        >${_banner.title}</h4>
                        <div
                            class="lead text-center text-dark d-none d-lg-block"
                            style="text-shadow: 0px -1px 1px #000000, 0 1px 1px #ffffff"
                        >${nl2br(description)}</div>
                    </div>
                </div>
            </div>
        `
    }

    if(_banner.templateType == 'light'){
        banner.html = `
            <div class="h-100 d-flex flex-column justify-content-center" style="background-color: rgba(255,255,255,0.5);">
                <div class="row">
                    <div class="col-lg-11 mx-auto">
                        <h4
                            class="h1 text-center text-dark font-weight-bold"
                            style="text-shadow: 0px -1px 1px #000000, 0 1px 1px #ffffff"
                        >${_banner.title}</h4>
                        <div
                            class="lead text-center text-dark d-none d-lg-block"
                            style="text-shadow: 0px -1px 1px #000000, 0 1px 1px #ffffff"
                        >${description}</div>
                    </div>
                </div>
            </div>
        `;
    }

    if(_banner.templateType == 'dark'){
        banner.html = `
            <div class="h-100 d-flex flex-column justify-content-center" style="background-color: rgba(0,0,0,0.5);">
                <div class="row">
                    <div class="col-lg-11 mx-auto">
                        <h4
                            class="h1 text-center text-white font-weight-bold"
                            style="text-shadow: 0px -1px 1px #000000;"
                        >${_banner.title}</h4>
                        <div
                            class="lead text-center text-white d-none d-lg-block"
                            style="text-shadow: 0px -1px 1px #000000;"
                        >${nl2br(description)}</div>
                    </div>
                </div>
            </div>
        `
    }

    if(_banner.templateType == 'custom'){
        const headerColor = rgbaToHtml(_banner.headerColor, '#ffffff')
        const headerFontFamily = _banner.headerFontFamily ? ('font-family: ' + _banner.headerFontFamily + '!important') : ''
        const headerFontSize = _banner.headerFontSize ? ('font-size: ' + _banner.headerFontSize + 'px') : headerFontFamily ? 'font-size: 2.25rem' : ''
        const headerClass = headerFontSize ? '' : 'h4'
        const headerShadow = _banner.headerShadow ? 'text-shadow: 0px -1px 1px #000000, 0 1px 1px #ffffff' : ''

        const descColor = rgbaToHtml(_banner.descColor, '#ffffff')
        const descFontFamily = _banner.descFontFamily ? ('font-family: ' + _banner.descFontFamily + '!important') : ''
        const descFontSize = _banner.descFontSize ? ('font-size: ' + _banner.descFontSize + 'px') : descFontFamily ? 'font-size: 1.125rem' : ''
        const descClass = descFontSize ? '' : 'lead'
        const descShadow = _banner.descShadow ? 'text-shadow: 0px -1px 1px #000000, 0 1px 1px #ffffff' : ''

        const bgColor = _banner.backgroundColorActive && _banner.backgroundColor && _banner.backgroundColor.a ? rgbaToHtml(_banner.backgroundColor) : 'rgba(0,0,0,0)'

        banner.html = `
            <div class="h-100 d-flex flex-column justify-content-center" style="background-color: ${bgColor};">
                <div class="mx-auto p-2">
                    <div
                        class="text-center font-weight-bold ${headerClass}"
                        style="color: ${headerColor};${headerFontSize};${headerFontFamily};${headerShadow}"
                    >${_banner.title}</div>
                    <div
                        class="text-center d-none d-lg-block ${descClass}"
                        style="color: ${descColor};${descFontSize};${descFontFamily};${descShadow}"
                    >${nl2br(description)}</div>
                </div>
            </div>
        `
    }

    return banner
}

export {
	bannerIndex,
	bannerViews,
	bannerClick,
	bannerDetails,
	bannerDetailsBy,
	bannerCreate,
	userBanners,
	bannerShow,
	bannerUpdate,
	bannerDelete,
	bannerPurchase,
	nl2br,
	bannerPlaces,
	bannerPlaceNameBy,
	placementKeyBy,
	postToBanner,
	getImages,
	defaultBgImages,
	rgbaToHtml,
	convertBanner,
	convertLocations
}